import { useEffect, useMemo, useState } from 'react';

import Modal from '@components/modal/modal.component';
import { Select } from '@components/custom-select/select';
import {
    SelectItem,
    SelectItemType,
} from '@components/custom-select/select-item';
import { useDebounce } from '@hooks/use-debounce';

import styles from './coupons-modal.module.scss';

type Props = {
    coupons: { id: number; code: string; discount: number }[];
    onSearchCoupon: (query: string) => void;
    onConfirm: (couponId: number) => void;
    onDiscard: () => void;
};

const CouponsModal = ({
    coupons,
    onSearchCoupon,
    onConfirm,
    onDiscard,
}: Props) => {
    const [query, setQuery] = useState('');
    const debouncedQuery = useDebounce(query, 500);

    const [couponId, setCouponId] = useState<number>();

    const items: SelectItemType[] = useMemo(() => {
        return coupons.map((coupon) => ({
            id: coupon.id,
            label: coupon.code,
            supportingText: `- ${coupon.discount}%`,
        }));
    }, [coupons]);

    useEffect(() => {
        onSearchCoupon(debouncedQuery);
    }, [debouncedQuery]);

    return (
        <Modal onConfirm={() => onConfirm(couponId!)} onDiscard={onDiscard}>
            <div className={styles.couponModal}>
                <header>
                    <h4>Seleccionar cupón</h4>
                    <span>
                        Los cupones afectan el precio final de la compra.
                    </span>
                </header>
                <section>
                    <Select
                        items={items}
                        placeholder="Selecciona un cupón"
                        searchable={true}
                        onSearch={setQuery}
                        onSelect={(item) => setCouponId(item.id as number)}
                    >
                        {items.map((item) => (
                            <SelectItem
                                key={item.id}
                                id={item.id}
                                supportingText={item.supportingText}
                            >
                                {item.label}
                            </SelectItem>
                        ))}
                    </Select>
                </section>
            </div>
        </Modal>
    );
};

export { CouponsModal };
